export default __webpack_public_path__ + "static/media/935.c4292475.png";